import { useState, useMemo, useEffect } from "react";
import debounce from "lodash/debounce";
import { Select, Spin } from "antd";

import { IOption } from "core/interfaces/data/IOption";
import IRemoteSelectProps from "components/RemoteSelect/IRemoteSelectProps";
import { DefaultOptionType } from "antd/lib/cascader";
import _ from "lodash";

const RemoteSelect: React.FC<IRemoteSelectProps> = ({ fetchOptions, OnSearch, OnChange, OnClear, defaultDatasource, debounceTimeout, ...Props }) => {
	const [fetching, setFetching] = useState<boolean>(false);
	const [options, setOptions] = useState<IOption[]>(defaultDatasource ?? []);
	const [searchValue, setSearchValue] = useState<string | undefined>();

	const fetcher = useMemo(() => {
		const loadOption = async (value: string) => {
			if (OnSearch) OnSearch(value);

			setSearchValue(value);
			setOptions([]);
			setFetching(true);

			const newOptions = await fetchOptions(value);

			setOptions(newOptions);

			setFetching(false);
		};

		return debounce(loadOption, debounceTimeout);
	}, [debounceTimeout, OnSearch, fetchOptions]);

	const onOptionChange = (value: any, option: any) => {
		setSearchValue(undefined);
		if (OnChange) OnChange(value, option);
	};
	const onClearSelection = () => {
		setSearchValue(undefined);
		if (OnClear) OnClear();
	};

	useEffect(() => {
		if (defaultDatasource && options !== defaultDatasource) {
			setOptions(defaultDatasource);
			onOptionChange(undefined, defaultDatasource[0]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [defaultDatasource]);

	return (
		<Select
			{...Props}
			filterOption={false}
			showSearch
			searchValue={searchValue ?? Props.searchValue ?? Props.value}
			onSearch={fetcher}
			onChange={onOptionChange}
			notFoundContent={fetching ? <Spin size="small" /> : null}
			options={_.flatMap(options, (val) => {
				let res: DefaultOptionType = {
					key: val.key,
					value: val.value,
					label: val.label,
				};

				return res;
			})}
			onClear={onClearSelection}
		/>
	);
};

export default RemoteSelect;
